import { c as _c } from "react/compiler-runtime";
import { useState, useMemo, useCallback, useEffect, useRef } from 'react';
export function useElementFitsContainer(t0) {
  const $ = _c(5);
  const fallbackWidth = t0 === undefined ? 100 : t0;
  const container = useRef(null);
  const ref = useRef(null);
  const [width, setWidth] = useState(fallbackWidth);
  const [windowWidth, setWindowWidth] = useState(fallbackWidth + 100);
  const [offset, setOffset] = useState(16);
  const safeWindow = typeof window !== "undefined" ? window : null;
  const fitsContainer = windowWidth > 640 || width < windowWidth - offset * 2;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (ref.current !== null) {
        setWidth(ref.current.clientWidth);
      }
      setWindowWidth(safeWindow?.innerWidth ?? 0);
      setOffset(container.current?.offsetLeft ?? 16);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleResize = t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      handleResize();
      safeWindow?.addEventListener("resize", handleResize);
      return () => {
        safeWindow?.removeEventListener("resize", handleResize);
      };
    };
    t3 = [handleResize];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== fitsContainer) {
    t4 = [container, ref, fitsContainer];
    $[3] = fitsContainer;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4 as const;
}